import {useMemo} from 'react';

import {Card} from 'shells/card/card';
import {MatrixHeatmap} from 'shells/table/matrix-heatmap/matrix-heatmap';

import type {AvailabilityReportFragment} from 'nutshell-graphql-types';

import {mapReportToRows} from './helpers';

interface Props {
    report: AvailabilityReportFragment | null;
    isLoading: boolean;
}

export function AvailabilityMatrixHeatmap(props: Props) {
    const rows = useMemo(
        () => (props.report ? mapReportToRows(props.report, 15, 15) : []),
        [props.report]
    );

    return (
        <Card hasBorder={true} hasShadow={true} borderRadius={8} fitHeight={true}>
            <div className='pad-16 overflow-x-auto'>
                <MatrixHeatmap
                    header='Availability heatmap'
                    subheader='What viewers saw when they opened your booking link'
                    keyName='Availability:'
                    rows={rows}
                    columnAxisLabel='Days away'
                    rowPrimaryHeaderLabel='Date'
                    rowMetricHeaderLabel='Conv.'
                    isLoading={props.isLoading}
                    expectedRowCount={15}
                />
            </div>
        </Card>
    );
}
